import { useState } from "react";

const PdfViewerDownloader = ({ pdfUrl, fileName }) => {
  const [clickTimeout, setClickTimeout] = useState(null);

  const handleClick = () => {
    if (clickTimeout) {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
    } else {
      const timeout = setTimeout(() => {
        window.open(pdfUrl, "_blank");
        setClickTimeout(null);
      }, 250); // Delay to differentiate single and double-click
      setClickTimeout(timeout);
    }
  };

  const handleDoubleClick = () => {
    if (clickTimeout) {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
    }
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = fileName || "document.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      className="text-center cursor-poInter text-white hover:text-[#333333] p-4 rounded shadow bg-[#66B2FF] hover:bg-white hover:border hover:border-[#333333]"
    >
      📄 Click to View / Double Click to Download
    </div>
  );
};

export default PdfViewerDownloader;
